// extracted by mini-css-extract-plugin
export default {"listItemContainer":"ListItem_listItemContainer__fyBp7","consentLinkContainer":"ListItem_consentLinkContainer__dLVUy"};